import {
  NotifyInterviewInviteFull,
  NotifyIcCheckFull,
  NotifyUpdateResumeFull,
  NotifyIconPublishedFull,
  NotifyVerifyEmailFull,
  NotifyVerifyPhoneFull,
  NotifyUnansweredVideo,
  Briefcase,
} from '@jobseeker/lotus/icons';

type NotificationType = {icon: string; color: string};

const NOTIFICATION_TYPE: {[key: number]: NotificationType} = {
  1: {icon: NotifyIconPublishedFull, color: '#56BAEA'},
  2: {icon: NotifyIcCheckFull, color: '#75CE93'},
  3: {icon: NotifyInterviewInviteFull, color: '#3DAB35'},
  4: {icon: NotifyVerifyPhoneFull, color: '#B4B9D8'},
  5: {icon: NotifyVerifyEmailFull, color: '#FFBE28'},
  6: {icon: NotifyUpdateResumeFull, color: '#F2998F'},
  11: {icon: NotifyUnansweredVideo, color: '#F2998F'},
  14: {icon: Briefcase, color: '#75CE93'},
  15: {icon: Briefcase, color: '#F2998F'},
};
const getIconClassType = (type: number) => {
  return NOTIFICATION_TYPE[type] || {icon: '', color: ''};
};

export {getIconClassType};
